
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RecordList from './RecordList.vue'

@Component({
	components: {
		RecordList,
	},
})
export default class OrderLog extends Vue {
	// 当前播放器播放的录音id
	private playingId = ''
	private recordTypes = [
		{
			type: 'injured',
			titleDesc: '伤者录音',
			recordName: 'injuredAudioList',
			recordList: [],
		},
		{
			type: 'owner',
			titleDesc: '车主录音',
			recordName: 'ownerAudioList',
			recordList: [],
		},
	]

	@Prop()
	private data!: any

	@Prop()
	private orderStatus!: string

	@Watch('data')
	private onDataChange() {
		const data = this.data || {}
		let id = 0
		this.recordTypes.forEach((item: any) => {
			let urlList = data[item.recordName] || []
			this.$set(
				item,
				'recordList',
				urlList.map((callObj: object, index: number) => {
					return {
						picName: item.titleDesc,
						picId: id++,
						...callObj,
					}
				})
			)
		})
	}

	private onPlay(recordObj: any, list: any[]) {
		if (!recordObj) {
			return
		}
		this.playingId = recordObj.picId
		if (recordObj) {
			this.$audioPlayer.play(recordObj)
		}
	}

	private activated() {
		// 添加关闭播放器监听
		this.$audioPlayer.addClearListener(() => {
			this.playingId = ''
		})
	}

	private deactivated() {
		// 先关闭播放器再移除关闭播放器监听
		this.$audioPlayer.removeClearListener()
	}
}
